'use client';

import React, { useEffect } from 'react';
import Skeleton from '@frontend/jetlend-web-ui/src/ui/Skeleton/Skeleton';
import styles from './FaqItem/FaqItem.module.scss';

export default function BaseFaqSectionSkeleton () {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const items = [1, 2, 3, 4, 5];

    return (
        <div className={styles['list--skeleton']}>
            {items?.map((_, index) => {
                return <Skeleton key={index} className={styles['block--skeleton']} />;
            })}
        </div>
    );
};